import { Observable } from "rxjs";
import { Comment } from "../../models/comment";

export abstract class CommentApi {
  public abstract getPredefinedComments(): Observable<Comment[]>;
}
